module.exports = __webpack_public_path__ + "static/media/stroke.dacb51fa.png";